export default __webpack_public_path__ + "static/media/1A.d4ca5e7a.JPG";